import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Merk } from '../dto/merk';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class MerkService extends CrudService<Merk> {

    constructor(injector: Injector) { super(Merk, injector); }

}
